module.exports = "/images/products-icon-white.svg?fc8cf96e36c8edf17320ea009ab51e58";